import React, { Component } from 'react'
import Modal from 'react-bootstrap/Modal';
 
const ChangeLocationChangeReginModel = (props) => {
return (
<Modal {...props} className="changeLocation-model-popup">
    {props.state.CL_ModalSH && 
      <section className='changeLoc-modal change-region-modal'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
            <section className="model-content-blk">
                <section className='content'>
                  <h1>Change Location</h1>
                  <section className='accodion-blk'>
                    <section className="accordion" id="changeLocationAccordion">
                      {
                        props.state.locationUniqueState.map((uniqueData, uIndex) => {
                          return(
                            <div className="accordion-item">
                              <h2 className="accordion-header" id={`heading-${uIndex}`}>
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${uIndex}`} aria-expanded="true" aria-controls={`collapse-${uIndex}`}>
                                  <aside className='form-group'>
                                    <label htmlFor={`regioninput-${uIndex}`} className='d-block'>
                                      <aside className='lft text-start'>
                                        <p>{uniqueData}</p>
                                      </aside>
                                    </label>
                                  </aside>
                                </button>
                              </h2>
                              <div id={`collapse-${uIndex}`} className="accordion-collapse collapse" aria-labelledby={`heading-${uIndex}`} data-bs-parent="#changeLocationAccordion">
                                <div className="accordion-body">
                                  <ul>
                                    {
                                      props.state.locationsJson.map((locData, index) => {
                                        if((locData.state == uniqueData) && (locData.subscriptionEnabled == true)){
                                          return(
                                            <li key={index} className={props.state.locPopupIndex == index ? 'active':locData.name == props.state.loc_name ? 'active':''}><a onClick={(e) => props.ChangeLoc_PopupClick(e, index, locData)} href="javascript:;" title={locData.name}>{locData.name}</a></li>
                                          )
                                        }
                                      })
                                    }
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </section>
                  </section>
                </section>
            </section>
        </Modal.Body>
      </section>
    }
    {props.state.CR_ModalSH &&
      <section className='change-region-modal'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
          <section className="model-content-blk">
            <section className='content'>
              <h1>Change Region</h1>
              <section className='accodion-blk'>
                <section className="accordion" id="accordionExample">
                  {
                    props.state.regionsPopupData.length > 0 &&
                      props.state.regionsPopupData.map((regionData, reIndex) => {
                        var defaultCheck = false;
                        if(reIndex == props.state.CR_getIndex){
                          defaultCheck = true
                        }else{
                          defaultCheck = false
                        }
                        return(
                          <div className="accordion-item" key={reIndex}>
                            <h2 className="accordion-header" id={`heading-${reIndex}`}>
                              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${reIndex}`} aria-expanded="true" aria-controls={`collapse-${reIndex}`}>
                                <aside className='form-group'>
                                  {/* <input onChange={(e) => props.Plan_CR_onChangeFun(e, reIndex)} type="radio" name="region-1" id={`regioninput-${reIndex}`} defaultChecked={`${defaultCheck ? 'true':''}`} /> */}
                                  <input onChange={(e) => props.Plan_CR_onChangeFun(e, reIndex)} type="radio" name="region-1" id={`regioninput-${reIndex}`} />
                                  <label htmlFor={`regioninput-${reIndex}`} className='d-block'>
                                    <aside className='lft text-start'>
                                      <p>{regionData.name}</p>
                                    </aside>
                                    <span className="radio-btn">&nbsp;</span>
                                  </label>
                                </aside>
                              </button>
                            </h2>
                            <div id={`collapse-${reIndex}`} className="accordion-collapse collapse" aria-labelledby={`heading-${reIndex}`} data-bs-parent="#accordionExample">
                              <div className="accordion-body">
                                <ul>
                                  {
                                    regionData.Theater.map((theatreData, thIndex) => {
                                      return(
                                        <li key={thIndex}><a href="javascript:;" title={theatreData}>{theatreData}</a></li>
                                      )
                                    })
                                  }
                                </ul>
                              </div>
                            </div>
                          </div>
                        )
                      })
                  }
                </section>
              </section>
              {
                props.state.regionsPopupData.length > 0 ?
                <section className='modal-btn text-center py-3'>
                  {/* <a className={props.CR_applyDisabled() ? '':'disabled'} onClick={props.RegionApplyBtn} href='javascript:;' title='APPLY'>APPLY</a> */}
                  <a onClick={props.RegionApplyBtn} href='javascript:;' title='APPLY'>APPLY</a>
                </section>
                :
                <aside className='error-msg text-center'>
                  <p>No Locations</p>
                </aside>
              }
            </section>
          </section>
        </Modal.Body>
      </section>
    }
    {props.state.CR_TL_ModalSH && 
      <section className='changeLoc-modal region-popup change-region-modal'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
            <section className="model-content-blk">
                <section className='content'>
                  <h1>{props.state.allLoc_Name}</h1>
                  <section className='accodion-blk'>
                    <section className="accordion" id="regionAccordion">
                      {
                        props.state.regionUniquePopup.map((uniqueData, uIndex) => {
                          return(
                            <div className="accordion-item">
                              <h2 className="accordion-header" id={`heading-${uIndex}`}>
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${uIndex}`} aria-expanded="true" aria-controls={`collapse-${uIndex}`}>
                                  <aside className='form-group'>
                                    <label htmlFor={`regioninput-${uIndex}`} className='d-block'>
                                      <aside className='lft text-start'>
                                        <p>{uniqueData}</p>
                                      </aside>
                                    </label>
                                  </aside>
                                </button>
                              </h2>
                              <div id={`collapse-${uIndex}`} className="accordion-collapse collapse" aria-labelledby={`heading-${uIndex}`} data-bs-parent="#regionAccordion">
                                <div className="accordion-body">
                                  <ul>
                                    {
                                      props.state.locationsJson.map((locNameData, index) => {
                                        return(
                                          props.state.region_firstObj.map((regionData, reIndex) => {
                                            return(
                                              regionData.Theater.map((thteData, thIndex) => {
                                                if((locNameData.state == uniqueData) && (locNameData.name == thteData)){
                                                  return(
                                                    <li key={index}><a className='cursor-default' href="javascript:;" title={`${locNameData.city} - ${thteData}`}>{`${locNameData.city} - ${thteData}`}</a></li>
                                                  )
                                                }
                                              })
                                            )
                                          })
                                        )
                                      })
                                    }

                                    {/* {
                                      props.state.locationsJson.map((locNameData, index) => {
                                        if(locNameData.state == uniqueData){
                                          return(
                                            <li key={index}><a className='cursor-default' href="javascript:;" title={`${locNameData.city} - ${locNameData.name}`}>{`${locNameData.city} - ${locNameData.name}`}</a></li>
                                          )
                                        }
                                      })
                                    } */}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </section>
                  </section>
                  {/* <ul>
                    {
                      props.state.region_firstObj.map((firstData, index) => {
                        return(
                          firstData.Theater.map((thteData, thIndex) => {
                            return(
                              <li key={thIndex}><a href="javascript:;" title={thteData}>{thteData}</a></li>
                            )
                          })
                        )
                      })
                    }
                  </ul> */}
                </section>
            </section>
        </Modal.Body>
      </section>
    }
    {props.state.All_theatre_ModalSH && 
      <section className='changeLoc-modal all-theatre-popup change-region-modal'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
            <section className="model-content-blk">
                <section className='content'>
                  <h1>All CMX Theatres</h1>
                  <section className='accodion-blk'>
                    <section className="accordion" id="allTheatreAccordion">
                      {
                        props.state.allTheatreUniqueState.map((uniqueData, uIndex) => {
                          return(
                            <div className="accordion-item">
                              <h2 className="accordion-header" id={`heading-${uIndex}`}>
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${uIndex}`} aria-expanded="true" aria-controls={`collapse-${uIndex}`}>
                                  <aside className='form-group'>
                                    <label htmlFor={`regioninput-${uIndex}`} className='d-block'>
                                      <aside className='lft text-start'>
                                        <p>{uniqueData}</p>
                                      </aside>
                                    </label>
                                  </aside>
                                </button>
                              </h2>
                              <div id={`collapse-${uIndex}`} className="accordion-collapse collapse" aria-labelledby={`heading-${uIndex}`} data-bs-parent="#allTheatreAccordion">
                                <div className="accordion-body">
                                  <ul>
                                    {
                                      props.state.locationsJson.map((locData, index) => {
                                        if(locData.state == uniqueData){
                                          return(
                                            <li key={index}><a className='cursor-default' href="javascript:;" title={`${locData.city} - ${locData.name}`}>{`${locData.city} - ${locData.name}`}</a></li>
                                          )
                                        }
                                      })
                                    }
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </section>
                  </section>
                </section>
            </section>
        </Modal.Body>
      </section>
    }
    {props.state.AnnualBenefits && 
      <section className='changeLoc-modal region-popup'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
            <section className="model-content-blk">
                <section className='content'>
                  <h1>Benefits Include:</h1>
                  <ul>
                    <li><a href="javascript:;">Free Ticket on Your Birthday</a></li>
                    <li><a href="javascript:;">Free Ticket on Your Anniversary</a></li>
                    <li><a href="javascript:;">$7 tickets on Wednesday</a></li>
                    <li><a href="javascript:;">$20 Food & Beverage Voucher on Your Birthday</a></li>
                    <li><a href="javascript:;">Earn 15 points per $1 on Food & Beverages</a></li>
                  </ul>
                </section>
            </section>
        </Modal.Body>
      </section>
    }
    {props.state.MonthlyBenefits && 
      <section className='changeLoc-modal region-popup'>
        <a onClick={props.plan_CL_closeBtn} className='close-icon' href='javascript:;'>&nbsp;</a>
        <Modal.Body>
            <section className="model-content-blk">
                <section className='content'>
                  <h1>Benefits Include:</h1>
                  <ul>
                    <li><a href="javascript:;">Free Ticket on Your Birthday</a></li>
                    <li><a href="javascript:;">Free Ticket on Your Anniversary</a></li>
                    <li><a href="javascript:;">$7 tickets on Wednesday</a></li>
                    <li><a href="javascript:;">Earn 10 points per $1 on Food & Beverages</a></li>
                  </ul>
                </section>
            </section>
        </Modal.Body>
      </section>
    }
</Modal>
)}

export default ChangeLocationChangeReginModel;
